import React from 'react';
import {message, notification} from "antd";
import {AgregarFaltantes} from "./AgregarFaltantes";

/**
 * @Respuestas
 * Regresa el estatus en un mensaje al usuario
 * @res = mensaje
 * @text = texto extra
 * @time = tiempo de duración de la notificación
 */
export const Respuestas = (res, text = "", mostrar = true) => {
  let _success = false;
  if (!res) return "Error en respuesta";

  const eliminaDuplicados = (arr) => {
    return arr.filter((valor, indice) => {
      return arr.indexOf(valor) === indice;
    });
  }

  if (res?.status >= 400 && res?.status < 499) {
    _success = false;
    if (res?.errores !== null) {
      let errores = eliminaDuplicados(Object.values(res?.errores))
      notification.error({
        message: 'Atención',
        description: errores.map((e, i) => <React.Fragment key={`${i}-error`}><span>- {e}</span><br/></React.Fragment>),
        placement: 'bottomRight',
        time: 1
      });
    } else {
      notification.error({
        message: 'Atención',
        description: res?.mensaje,
        placement: 'bottomRight',
        time: 1
      });
    }
  } else if ((res?.status >= 500) && res?.errores === null) {
    _success = false;

    notification.error({
      message: 'Atención',
      description: res?.mensaje === null ? 'Hubo un problema del lado del servidor.' : res?.mensaje,
      placement: 'bottomRight',
      time: 1
    });
  } else if (res?.status >= 200 && res?.status < 399) {
    _success = true;
    if (mostrar) {
      notification.success({
        message: '¡Éxito!',
        description: text === "" ? `${res?.mensaje}` : `${res?.mensaje}, ${text}`,
        placement: 'bottomRight',
        time: 1
      });
    }
  } else if (res === "error") {
    _success = false;
    if (mostrar) {
      notification.error({
        message: 'Atención',
        description: text,
        placement: 'bottomRight',
        time: 1
      });
    }

  } else if (res === "exito") {
    _success = true;
    if (mostrar) {
      notification.success({
        message: '¡Éxito!',
        description: text,
        placement: 'bottomRight',
        time: 1
      });
    }
  }

  if (res.file) {
    /*if (res.file.status !== 'uploading') {
      console.log(res.file, res.fileList);
    }*/
    if (res.file.status === 'done') {
      notification.success({
        message: '¡Éxito!',
        description: `${res.file.name} el archivo se subio correctamente`,
        placement: 'bottomRight',
        time: 1
      });
    } else if (res.file.status === 'error') {
      console.log(res.file);
      notification.error({
        message: 'Atención',
        description: res?.file?.response?.mensaje || `Fallo en la subida del archivo.`,
        placement: 'bottomRight',
        time: 1
      });
    }
  }

  return _success;
};